export const styles = {
  facebookButton: {
    color: '#fff',
    fontFamily:
      '"Varela Round", "K2D", "Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 'normal'
  }
}
